// src/components/chat/RNChatbot.jsx
import React, { useEffect, useRef, useState } from "react";
import { askChat, handoffToHuman } from "../services/ChatServices";
import { addGiftToCart } from "../services/GiftServices";
import { addToLocalCart,addToCart ,addOrUpdateServerItem} from "../services/CartServices";
import "./ChatWidget.css";
import bot from "../assets/Bot1.jpg";


const SUGGESTIONS = [
  "Track my latest order",
  "What are the shipping charges?",
  "Do you have Cash on Delivery?",
  "What’s your return policy?",
  "Heena Powder  ",
  "What’s in my cart?",
];

export default function RNChatbot({ onCartBounce }) {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [input, setInput] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "🌿 Hi! I’m your Roupan Naturals assistant. Ask me about products, gifts, cart, orders, shipping or returns." },
  ]);

  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, open]);

  const send = async (text) => {
    if (!text.trim()) return;
    const conversation = [...messages, { role: "user", text }];
    setMessages(conversation);
    setSending(true);
    try {
      const data = await askChat(text, conversation);
      const suffix = data.needLogin ? "\n\n➡️ Please log in so I can pull your order/cart." : "";
      const reply = { role: "assistant", text: (data.reply || "…") + suffix };
      if (Array.isArray(data.products) && data.products.length) reply.products = data.products;
      setMessages(m => [...m, reply]);
    } catch (e) {
      setMessages(m => [...m, { role: "assistant", text: "❌ Oops! Something went wrong. Please try again." }]);
    } finally {
      setSending(false);
      setInput("");
    }
  };

  const handoff = async () => {
    try {
      const data = await handoffToHuman(messages);
      if (data?.url) window.open(data.url, "_blank");
    } catch {
      setMessages(m => [...m, { role: "assistant", text: "Couldn’t start WhatsApp chat, please try again." }]);
    }
  };

const handleAdd = async (p) => {
  try {
    if (p.id && p.id.toString().startsWith("g-")) {
      // 🎁 Gift flow
      const giftId = Number(p.id.slice(2));
      const payload = {
        type: "GIFT",
        giftProductId: giftId,
        quantity: 1,
      };
      await addGiftToCart(payload);
      if (onCartBounce) onCartBounce();
      setMessages(m => [
        ...m,
        { role: "assistant", text: `🎁 Gift *${p.name}* added to your cart!` }
      ]);
    } else {
      // 🛒 Normal product flow
      const product = {
        ...p,
        productId: p.productId || p.id,
        price: p.discountedPrice ? Number(p.discountedPrice) : Number(p.price),
      };

      const token = localStorage.getItem("token");

      if (token) {
        // Logged in → use server cart
        await addToLocalCart(product, 1);
      } else {
        // Guest → local storage
        await addToLocalCart(product, 1);
      }

      if (onCartBounce) onCartBounce();
      setMessages(m => [
        ...m,
        { role: "assistant", text: `🛒 Product *${p.name}* added to your cart!` }
      ]);
    }
  } catch (err) {
    console.error("Error adding to cart:", err);
    setMessages(m => [
      ...m,
      { role: "assistant", text: "❌ Couldn’t add to cart. Try again." }
    ]);
  }
};






  return (
    <>
      {/* Floating FAB */}
      <button
        className={`rncb-fab ${open ? "open" : ""}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Open support chat"
        title="Chat with us"
      >
        {open ? <span className="fab-close">✖</span> : <img src={bot} alt="Bot" />}
      </button>

      <div className={`rncb-panel ${open ? "open" : ""}`}>
        <div className="rncb-header">
          <div className="brand">
            <span className="leaf">🍃</span>
            <div className="brand-stack">
              <div className="brand-top">ROUPAN</div>
              <div className="brand-bottom">NATURALS</div>
            </div>
          </div>
          <button className="close" onClick={() => setOpen(false)}>✖</button>
        </div>

        <div className="rncb-body">
          {messages.map((m, i) => (
            <div key={i} className={`msg ${m.role}`}>
              <div className="bubble" dangerouslySetInnerHTML={{ __html: m.text.replace(/\n/g, "<br/>") }} />
              {m.products && (
                <div className="cards-style">
                  {m.products.map((p) => (
                    <div key={p.id} className="card-style">
                      {/* <img src={p.image} alt={p.name} /> */}
                      <div className="meta">
                        <div className="name">{p.name}</div>
                        <div className="price">₹{Number(p.price).toFixed(2)}</div>
                        {p.category && <div className="badge">{p.category}</div>}
                      </div>
                      <button onClick={() => handleAdd(p)} className="add">Add to cart</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Initial or manually triggered suggestions */}
  {(!messages.some(m => m.role === "user") || showSuggestions) && (
    <div className="suggestions">
      {SUGGESTIONS.map((s, i) => (
        <button key={i} onClick={() => send(s)}>
          {s}
        </button>
      ))}
    </div>
  )}

          <div className="quick">
            <button onClick={() => send("What’s in my cart?")}>🧺 Cart</button>
            <button onClick={() => send("Track my latest order")}>📦 Order</button>
            <button onClick={() => send("Birthday Gift")}>🎁 Gifts</button>
            <button className="human" onClick={handoff}>👤 Talk to a human</button>
            <button onClick={() => setShowSuggestions(s => !s)}>
              {showSuggestions ? "🔼" : "🔽"} Suggestions
            </button>

          </div>

          <div ref={endRef} />
        </div>

        <div className="rncb-input">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask me anything… (Payment, cart, orders, about products)"
            onKeyDown={(e) => e.key === "Enter" && !sending && send(input)}
            disabled={sending}
          />
          <button onClick={() => send(input)} disabled={sending || !input.trim()}>
            {sending ? "…" : "➤"}
          </button>
        </div>
      </div>
    </>
  );
}
